















import { Component, Vue, Prop } from 'vue-property-decorator';
import { IAboutSection, IAboutSectionList } from '@/store/modules/about/types/IAboutSection';

@Component({})
export default class AboutSection extends Vue {
  @Prop({ type: Object, required: true }) private section!: IAboutSection;

  private get list(): IAboutSectionList[] {
    return this.section.list;
  }
}
